import React, {useState, useCallback} from "react";

import withStyles from '@material-ui/core/styles/withStyles';
import {
    Create,
    FormTab,
    Edit,
    TextInput,
    TabbedForm,
    AutocompleteInput,
    SelectInput,
    DateInput,
    TopToolbar,
    ReferenceInput,
    Toolbar, SaveButton, DeleteButton,
    useGetOne, Loading, NumberInput, TextField, ShowButton
} from 'react-admin';
import {makeStyles} from "@material-ui/core";



const useStyles = makeStyles((theme) => ({

    documentacion_tipo: {display: 'inline-block', width: 200, marginLeft: 8},
    documentacion_tipo_d: {display: 'inline-block', width: 400, marginLeft: 8},
}));

const AutoridadesEdit = props => {
    const classes = useStyles();
    const [state, setState] = useState({});
    const [DocumentacionTipo, setDocumentacionTipo] = useState('');
    const [PersonaTipo, setPersonaTipo] = useState('');

    /// Búsqueda país
    var w_pais_legal = '', w_pais_comercial = '';

    const {data: Data, loading: Loading} = useGetOne('DocumentacionTipo', props.id);

    if (Data === undefined) {
    } else {
        w_pais_legal = Data.legal_pais;
        w_pais_comercial = Data.PaisComercial ? Data.PaisComercial.pais.trim() : '';
    }

    const {
        PaisLegal = w_pais_legal, PaisComercial = w_pais_comercial,
    } = state;

    const formatPaisLegal = v => {
        return PaisLegal
    };

    const formatPaisComercial = v => {
        return PaisComercial
    };

    const updatePaisLegal = useCallback(async (who) => {
        setState(state => ({
            ...state,
            pais_codigo_afip_legal: who.pais_codigo_afip,
            PaisLegal: who.pais.trim(),
        }));
    })


    const updatePaisComercial = useCallback(async (who) => {
        setState(state => ({
            ...state,
            pais_codigo_afip_comercial: who.pais_codigo_afip,
            PaisComecial: who.pais.trim(),
        }));
    })

    const establecerDocumentacionTipo = value => {
        if (value == null || value === '') return '';
        setDocumentacionTipo(value.trim());
        return value;
    };

    const establecerFecha = value => {
        if (value == null || value === '') return '';
        return value;
    };

    // Obtengo tipo de persona para cargar solapa correspondiente
    const establecerPersonaTipo = value => {
        if (value == null || value === '') return '';
        setPersonaTipo(value.trim());
        return value;
    };

    const cuitCuilFormat = value => {
        if (value == null || value === '') return '';

        //normalize string and remove all unnecessary characters
        var valueCuit = value.replace(/[^\d]/g, "");

        //check if number length equals to 11
        if (valueCuit.length == 11) {
            return value.replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
        }

        return value
    };

    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            <ShowButton basePath={basePath} record={data}/>
        </TopToolbar>
    );

    const redirect = (basePath, id, data) => `/DocumentacionTipo`;

    const CustomToolbar = props => (

        <Toolbar {...props}>
            <SaveButton
                label="Actualizar"
                transform={transform}
                submitOnEnter={false}
                disabled={props.pristine}
            />
            <DeleteButton undoable={false} redirect={redirect}/>
        </Toolbar>
    );
    const transform = data => {
        return {
            ...data
        }
    };

    const PostTitle = ({record}) => {
        return <span>Autoridades: {record ? `${record.nombre_apellido}` : ''}</span>;
    };

    return (
        <Edit title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm
                redirect={redirect}
                toolbar={<CustomToolbar/>}
            >
                {/*Datos*/}
                <FormTab label="DATOS Autoridades">
                    <TextInput label="Autoridad Código" source="autoridad_codigo"
                               variant="outlined"
                               formClassName={classes.autoridad_codigo}/>
                    <TextInput label="Nombre Apellido" source="nombre_apellido"
                               variant="outlined"
                               formClassName={classes.nombre_apellido}/>
                    <TextInput label="Adjudica Sector" source="adjudica_sector"
                               variant="outlined"
                               formClassName={classes.adjudica_sector}/>
                    <TextInput label="Firma Tipo" source="firma_tipo"
                               variant="outlined"
                               formClassName={classes.firma_tipo}/>
                    <NumberInput label="Importe Hasta Pesos" source="importe_hasta_pesos"
                                 variant="outlined"
                                 formClassName={classes.importe_hasta_pesos}  />

                    <br/>
                    <SelectInput
                        label="Pre Adjudica" source="pre_adjudica"
                        choices={[
                            {id: 'S', name: 'S'},
                            {id: 'N', name: 'N'},
                        ]} formClassName={classes.pre_adjudica}
                        variant="outlined"
                    />

                    <SelectInput
                        label="Conforma Adjudica" source="conforma_adjudica"
                        choices={[
                            {id: 'S', name: 'S'},
                            {id: 'N', name: 'N'},
                        ]} formClassName={classes.conforma_adjudica}
                        variant="outlined"
                    />



                </FormTab>
            </TabbedForm>
        </Edit>
    )
};
export default AutoridadesEdit;


